import React, { useState, useEffect } from "react";
import { IonCard, IonCardContent, IonCardHeader, IonIcon, IonText } from "@ionic/react";
import { bookmarkOutline, calendarOutline, personOutline } from "ionicons/icons";
// Types
import { Document } from "../../../@types/document";
import { DocumentStatusTag } from "../../../components/Document/DocumentStatusTag";
import api from "../../../utils/api";

interface CardItemListProps {
  document: Document;
}

export const DocumentCardItemList: React.FC<CardItemListProps> = ({ document }) => {
  const [thumbSrc, setThumbSrc] = useState('https://programacion.net/files/article/20161110041116_image-not-found.png');

  useEffect(() => {
    const fetchThumbnail = async () => {
      if (document.thumbArchive) {
        try {
          const token = localStorage.getItem('token');
          const response = await fetch(`${api.baseURL}archive/${document.thumbArchive?.id}`, {
            headers: {
              'Authorization': `Bearer ${token}`,
            },
          });

          if (response.ok) {
            const blob = await response.blob();
            const url = URL.createObjectURL(blob);
            setThumbSrc(url);
          } else {
            console.error('Error fetching thumbnail:', response.statusText);
          }
        } catch (error) {
          console.error('Fetch error:', error);
        }
      }
    };

    fetchThumbnail();
  }, [document.thumbArchive]);

  return (
    <IonCard routerLink={`/app/rrhh/acuerdos/${document.id}`} button style={{ height: "285px" }}>
      <IonCardHeader
        style={{ padding: 0, display: "flex", justifyContent: "center", background: "#cccccc" }}
      >
        <img
          src={thumbSrc}
          alt="Imagen documento"
          style={{
            height: "168px",
            objectFit: "cover",
            background: "white",
          }}
        />
        <div
          style={{
            position: "absolute",
            top: "22px",
            right: "15px",
          }}
        >
          <DocumentStatusTag document={document} />
        </div>
      </IonCardHeader>
      <IonCardContent>
        <IonText color="primary">
          <h1
            style={{ fontWeight: 500, height: "60px", fontSize: 20 }}
            className="custom-line-clamp"
          >
            {document.title}
          </h1>
        </IonText>

        <h3>
          <IonIcon icon={personOutline}></IonIcon>
          <IonText className="ion-padding-start">{document.author?.name}</IonText>
        </h3>

        <h4>
          <IonIcon icon={calendarOutline}></IonIcon>
          <IonText className="ion-padding-start">{document.createdAt || ""}</IonText>

          <IonIcon icon={bookmarkOutline} className="ion-padding-start" />
          <IonText className="ion-padding-start">{`${document.category?.name}`}</IonText>
        </h4>
      </IonCardContent>
    </IonCard>
  );
};